import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HolidayScreen from "./Components/Holiday/HolidayScreen";
import HolidayPackageDetails from "./Components/Holiday/HolidayPackageDetails";
import HotelSearch from "./Components/Hotels/HotelSearch";
import SearchSightSeeing from "./Components/SightSeeings/SearchSightSeeing";
import B2CLayout from "./Components/Profile/B2CLayout";
import DestinationPackages from "./Components/Holiday/PackageByDestination";
import FlightSearch from "./Components/Flight/SearchFlight";
import Flights from "./Components/Flight/Flights";
import FlightDetails from "./Components/Flight/FlightDetails";
import ReviewFlight from "./Components/Flight/ReviewFlight";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import FlightVoucher from "./Components/Flight/FlightVoucher";
import FlightInvoice from "./Components/Flight/FlightInvoice";
import HotelsList from "./Components/Hotels/HotelsList";
import HotelDetails from "./Components/Hotels/HotelDetails";
import HotelGuests from "./Components/Hotels/HotelGuests";
import HotelReview from "./Components/Hotels/HotelReview";
import HotelBookings from "./Components/Hotels/HotelBookings";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails";
import HotelVoucher from "./Components/Hotels/HotelVoucher";
import HotelInvoice from "./Components/Hotels/HotelInvoice";
import SightSeeingProducts from "./Components/SightSeeings/SightSeeingProducts";
import SightSeeingProduct from "./Components/SightSeeings/SightSeeingProduct";
import AboutUs from "./Components/StaticPages/AboutUs";
import TermsAndConditions from "./Components/StaticPages/Terms";
import Faq from "./Components/StaticPages/Faq";
import PrivacyPolicy from "./Components/StaticPages/PrivacyPolicy";
import RefundPolicy from "./Components/StaticPages/RefundPolicy";
import ContactUs from "./Components/StaticPages/ContactUs";
import AccountLayout from "./Components/Profile/AccountLayout";
import MyProfilePage from "./Components/Profile/MyProfilePage";
import MyFlightBookings from "./Components/Bookings/MyFlightBookings";
import MyFlightBookingDetails from "./Components/Bookings/MyFlightBookingDetails";
import HolidayResults from "./Components/Holiday/HolidayResults";
import UmrahPackageDetails from "./Components/Umrah/UmrahDetails";
import UmrahScreen from "./Components/Umrah/UmrahScreen";
import UmrahResults from "./Components/Umrah/UmrahResult";
import TravelTypeResults from "./Components/Holiday/PackagesByTravelType";
import HajjScreen from "./Components/Hajj/HajjScreen";
import HajjDetails from "./Components/Hajj/HajjDetails";
import HajjResults from "./Components/Hajj/HajjResut";
import MyHotelBookings from "./Components/Bookings/MyHotelBookings";
import MyHotelBookingDetails from "./Components/Bookings/MyHotelBookingDetails";


function App() {
  return (
    <>
      <Routes>
        <Route element={<B2CLayout />}>
          <Route path="/" element={<FlightSearch />} />
          <Route path="/flight/search" element={<FlightSearch />} />
          <Route path="/flight/:adults?/:kids?/:infants?/:isDomestic?" element={<Flights />} />
          <Route path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?" element={<FlightDetails />} />
          <Route path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?" element={<ReviewFlight />} />
          <Route path="/flight/bookings" element={<FlightBookings />} />
          <Route path="/flight/booking/:flightBookingId" element={<FlightBookingDetails />} />
          <Route path="/flight/voucher/:flightBookingId" element={<FlightVoucher />} />
          <Route path="/flight/invoice/:flightBookingId" element={<FlightInvoice />} />

          <Route path="/hotel/search" element={<HotelSearch />} />
          <Route path="/hotels" element={<HotelsList />} />
          <Route path="/hotel/details/:hotelId?" element={<HotelDetails />} />
          <Route path="/hotel/guests" element={<HotelGuests />} />
          <Route path="/hotel/review" element={<HotelReview />} />
        <Route path="/hotel/bookings" element={<HotelBookings />} />
        <Route path="/hotel/booking/:hotelBookingId" element={<HotelBookingDetails />} />
        <Route path="/hotel/voucher/:hotelBookingId" element={<HotelVoucher />} />
        <Route path="/hotel/invoice/:hotelBookingId" element={<HotelInvoice />} />

          <Route path="/holidays" element={<HolidayScreen />} />
          <Route path="/holiday-details/:packageId" element={<HolidayPackageDetails />} />
          <Route path="/holidays/search" element={<HolidayResults />} /> 
          <Route path="/packages/type/:travelTypeName" element={<TravelTypeResults />} /> 
          
          <Route path="/search/sightseeing" element={<SearchSightSeeing />} />
          <Route path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProducts />} />
        <Route path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProduct />} />
          <Route path="/destination/:destinationId" element={<DestinationPackages />} />  

          <Route path="/umrahs" element={<UmrahScreen />} />
          <Route path="/umrah-details/:packageId" element={<UmrahPackageDetails />} />
          <Route path="/umrah-packages/search" element={<UmrahResults />} />

          <Route path="/hajj" element={<HajjScreen  />} />
          <Route path="/hajj-details/:packageId" element={<HajjDetails />} />
          <Route path="/hajj-packages/search" element={<HajjResults />} />

          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route element={<AccountLayout />}>
            <Route path="/my-profile" element={<MyProfilePage />} />
            <Route path="/my-flightbookings" element={<MyFlightBookings />} />
            <Route path="/my-flight/booking/:flightBookingId" element={<MyFlightBookingDetails />} />
            <Route path="/my-hotelbookings" element={<MyHotelBookings />} />
            <Route path="/my-hotel/booking/:hotelBookingId" element={<MyHotelBookingDetails />} />
          </Route>
        </Route>
        {/*B2C END*/}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
